import React from 'react';

import Box from '@mui/material/Box';

import UtilisateurAgence from 'components/Shared/UtilisateurAgence';

import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

const IdentificationStep = ({ reclamation, onNextStepValid, onDetailChange, codeAgence }) => {

    const [emetteur, setEmetteur] = React.useState(null);

    React.useEffect(() => {
        init();
    }, []);


    // Modification
    React.useEffect(() => {

        let errors = [];

        if (emetteur) {
            var detail = {
                position: 0,
                code: ReclamationQualificationDetailCodes.ConfirmationEmetteur,
                type: ReclamationQualificationDetailType.UtilisateurId,
                libelle: 'Confirmation du nom émetteur',
                valeurInteger: emetteur.id,
                valeurObject:emetteur
            };

            errors.push({ key: ReclamationQualificationDetailCodes.ConfirmationEmetteur, errorMsg: null });

            onDetailChange(detail, errors, null);

        }
        else
        {

            errors.push({ key: ReclamationQualificationDetailCodes.ConfirmationEmetteur, errorMsg: "Veuillez vous identifier, s'il vous plaît." });

            var detailsToDelete = [];
            detailsToDelete.push(ReclamationQualificationDetailCodes.ConfirmationEmetteur);

            onDetailChange(null, errors, null);
        }

    }, [emetteur]);



    const init = () => {

        var detail = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.ConfirmationEmetteur);

        if (detail !== undefined && detail !== null) {
            setEmetteur(detail.valeurObject);
        }

        var nextStepValid = detail !== undefined && detail !== null && detail.valeurInteger > 0;

        onNextStepValid(nextStepValid);
    };


    const handleChange = (utilisateur) => {
        setEmetteur(utilisateur);
    };

    return (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box p={2} sx={{ width: 350, backgroundColor: 'white' }}>
                <UtilisateurAgence
                    onChange={handleChange}
                    codeAgence={codeAgence}
                    utilisateurId={emetteur ? emetteur.id : 0}
                    autoFocus
                />
            </Box>
        </Box>  
    );

}

export default IdentificationStep;

